/* eslint-disable max-len */
import 'react';

function CloseTagSvg(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width={6}
            height={6}
            viewBox="0 0 6 6"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g fill="currentColor" fillRule="nonzero">
                <path d="M.646.646A.5.5 0 011.284.59l.07.057 4.201 4.202a.5.5 0 01-.638.765l-.069-.058L.646 1.354a.5.5 0 010-.708z" />
                <path d="M5.555.646A.5.5 0 004.917.59l-.069.057L.646 4.848a.5.5 0 00.638.765l.07-.058 4.201-4.201a.5.5 0 000-.708z" />
            </g>
        </svg>
    );
}

export default CloseTagSvg;
